export interface CreateClientRequest {
    id?: string | null;
    titleId: string | null;
    firstName: string | null;
    middleNames: string | null;
    lastName: string | null;
    dateOfBirth: Date | string | null;
    email: string | null;
    telephone: string | null;
    mobile: string | null;
    accountStatusId: string | null;
    partnerPracticeId: string | null;
    originalSourceId: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    addressLine3: string | null;
    town: string | null;
    county: string | null;
    postcode: string | null;
    isForeignAddress: boolean | false;
    foreignAddress: string | null;
    occupation: string | null;
    relationshipStatusId: string | null;
    nationalInsuranceNumber: string | null;
    isSensitive: boolean;
    hasCourtOfProtection: boolean;
    hasChildren: boolean | null;
    hasChildrenUnderEighteen: boolean | null;
    isHomeOwner: boolean | null;
    isBusinessOwner: boolean | null;
    canPost: boolean;
    canText: boolean;
    canEmail: boolean;
    canTelephone: boolean;
}

export function createClientRequest(): CreateClientRequest {
    return {
        id: null,
        titleId: null,
        firstName: null,
        middleNames: null,
        lastName: null,
        dateOfBirth: null,
        email: null,
        telephone: null,
        mobile: null,
        accountStatusId: null,
        partnerPracticeId: null,
        originalSourceId: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        town: null,
        county: null,
        postcode: null,
        isForeignAddress: false,
        foreignAddress: null,
        occupation: null,
        relationshipStatusId: null,
        nationalInsuranceNumber: null,
        isSensitive: false,
        hasCourtOfProtection: false,
        hasChildren: null,
        hasChildrenUnderEighteen: null,
        isHomeOwner: null,
        isBusinessOwner: null,
        canPost: true,
        canText: true,
        canEmail: true,
        canTelephone: true,
    };
}
